import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import AddTicketItem from '../AddTicketItem';
import selectIsModalOpened from '../../../core/selectors/modal';
import { closeModal } from '../../../core/actions/modal';
import { selectHasMultipleEvents, selectSellFormData } from '../../selectors/sell-tickets';
import { addForm } from '../../actions/forms';
import { validateTicketCodes } from '../../actions/sell-tickets';
import { addTicketCodes } from '../../api/sell';
import { ADD_TICKETS_MODAL_NAME } from '../../constants/modal';
import { TICKET_CODES_FORM } from '../../reducers/features';

const AddTicketsModal = ({ goToNextStep, errorNotify }) => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => selectIsModalOpened(state, ADD_TICKETS_MODAL_NAME));
    const ticketCodes = useSelector((state) => selectSellFormData(state, TICKET_CODES_FORM));
    const hasMultipleEvents = useSelector(selectHasMultipleEvents);
    const isValidForm = ticketCodes.every((ticket) => ticket.isValid) && !hasMultipleEvents;
    const validateTickets = () => dispatch(validateTicketCodes(ticketCodes, errorNotify));

    return (
        <Modal show={isOpen} onHide={() => dispatch(closeModal(ADD_TICKETS_MODAL_NAME))} className="modal-fullscreen-sm-down">
            <Modal.Header closeButton><Modal.Title><FormattedMessage id="add_ticket_code"/></Modal.Title></Modal.Header>
            <Modal.Body>
                <div className="add-tickets__container">
                    {ticketCodes.map((ticket, index) => (
                        <div className="add-tickets__text mb-3" key={index}>
                            <p className="mb-3"><FormattedMessage id="add_ticket_code_text_1"/> <FormattedMessage id='sell_tickets_manually_text_codes'/></p>
                            <AddTicketItem ticket={ticket} index={index} countTickets={ticketCodes.length}/>
                        </div>
                    ))}
                    {isValidForm && <div className="alert alert-success mb-2"><FormattedMessage id="tickets_are_valid"/></div>}
                    <Button variant="outline-secondary" onClick={() => dispatch(addForm(TICKET_CODES_FORM, { code: '' }))}>
                        <i className="bi bi-plus-square"></i>&nbsp;<FormattedMessage id="add_new_ticket"/>
                    </Button>
                    {hasMultipleEvents
                        && <div className="alert alert-warning mt-3" role="alert">
                            <FormattedMessage id="multiple_events_warning"/>
                        </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                {isValidForm
                    ? <Button variant="primary" onClick={() => addTicketCodes(goToNextStep, errorNotify)}>
                        <FormattedMessage id="add_tickets"/></Button>
                    : <Button variant="primary" onClick={validateTickets}><FormattedMessage id="validate_ticket"/></Button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default AddTicketsModal;
